import clsx from 'clsx';

type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  length?: string; // e.g., '50%', '200px'
  className?: string;
};

export function Divider({
  orientation = 'horizontal',
  length = '100%',
  className = '',
}: DividerProps) {
  return (
    <div
      className={clsx(
        'mx-auto bg-gray-5',
        orientation === 'horizontal' ? 'h-[1px]' : 'my-auto h-full w-[1px]',
        className
      )}
      style={
        orientation === 'horizontal' ? { width: length } : { height: length }
      }
    />
  );
}
